import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import AddressProp from '../../../../commonComponents/propTypes/addressProp';
import PinIcon from '../../../../commonComponents/icons/PinIcon';
import { displayUserName } from '../../../../services/utilityFunctions';
import VanIcon from '../../../../commonComponents/icons/VanIcon';
import ShippingProp from '../../../profile/propTypes/shippingProp';

function ShippingSection(props) {
  const { shipping, title, wrapperClass } = props;

  if (!shipping) {
    return null;
  }

  const { name, description } = shipping;

  return (
    <div className={`address-container ${wrapperClass}`}>
      {title ? (
        <div className="title-container">
          <VanIcon />
          <p className="title">{title}</p>
        </div>
      ) : null}
      {name ? <p className="field">{name}</p> : null}
      {description ? <p className="field">{description}</p> : null}
    </div>
  );
}

ShippingSection.propTypes = {
  title: PropTypes.string,
  wrapperClass: PropTypes.string,
  shipping: PropTypes.shape(ShippingProp.propType).isRequired,
};

ShippingSection.defaultProps = {
  title: '',
  wrapperClass: '',
};

export default translate(ShippingSection);
